import { createContext, Dispatch } from "react";

export interface PlaidState {
  linkSuccess: boolean;
  isItemAccess: boolean;
  isPaymentInitiation: boolean;
  linkToken: string | null;
  accessToken: string | null;
  itemId: string | null;
  isError: boolean;
  linkTokenError: {
    error_message: string;
    error_code: string;
    error_type: string;
  };
}

export const initialState: PlaidState = {
  linkSuccess: false,
  isItemAccess: true,
  isPaymentInitiation: false,
  linkToken: "", // Don't set to null or error message will show up briefly when site loads
  accessToken: null,
  itemId: null,
  isError: false,
  linkTokenError: {
    error_type: "",
    error_code: "",
    error_message: ""
  }
};

export type PlaidAction = {
  type: "SET_STATE";
  state: Partial<PlaidState>;
};

interface PlaidContext extends PlaidState {
  dispatch: Dispatch<PlaidAction>;
}

export const PlaidContext = createContext<PlaidContext>(initialState as PlaidContext);
